module.exports = __webpack_public_path__ + "media/virtualStaging/galleryImage3-373c567d.jpeg";